import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class Notifications extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  getNotificationsCount(params) {
    return this.httpService.get("support/count-notice", {
      headers,
      params,
    });
  }

  getNotifications(params) {
    return this.httpService.get("support/notices", {
      headers,
      params,
    });
  }

  getNotificationsFile(params) {
    return this.httpService.get("support/attachment-notice", {
      headers: {
        ...headers,
      },
      responseType: "blob",
      params,
    });
  }

  putIsRead(data) {
    return this.httpService.put("support/read-notice", data, {
      headers,
    });
  }

  getPostTypes(params) {
    return this.httpService.get("support/notice/post-type", {
      headers,
      params,
    });
  }

  getGroupNotice(params) {
    return this.httpService.get("support/notice/group-notice", {
      headers,
      params,
    });
  }

  getNotificationsAdmin(params) {
    return this.httpService.get("support/notice/admin", {
      headers,
      params,
    });
  }

  postNotice(data) {
    let header = { ...headers, "Content-Type": "multipart/form-data" };
    return this.httpService.post("support/notice", data, {
      headers: header,
    });
  }

  getNotificationsReader(params) {
    return this.httpService.get("/support/notice", {
      headers,
      params,
    });
  }

  deleteNotification(data) {
    return this.httpService.delete("support/notice", { headers, data });
  }
}
const NotificationsService = new Notifications();
export default NotificationsService;
